import paths from '@paths';
import {
  LandingRoutes,
  PrivacyPolicyRoutes,
  TermsRoutes,
  CommercialRoutes,
  QuestionsRoutes,
  ContactRoutes,
  OptionsRoutes,
  PriceRoutes,
  NotFoundRoutes,
  SafetyRoutes,
  CsvRoutes,
  ReasonRoutes,
} from '../Routes';

// NOTE: NoutFoundRoutesが配列の一番最後になる
const routing: AppRoute[] = [
  {path: paths.terms.main, component: TermsRoutes, exact: true},
  {path: paths.landing.main, component: LandingRoutes, exact: true},
  {path: paths.privacyPolicy.main, component: PrivacyPolicyRoutes, exact: true},
  {path: paths.contact.main, component: ContactRoutes, exact: true},
  {path: paths.commercial.main, component: CommercialRoutes, exact: true},
  {path: paths.options.main, exact: true, component: OptionsRoutes},
  {path: paths.questions.main, component: QuestionsRoutes, exact: true},
  {
    path: paths.price.main,
    exact: true,
    component: PriceRoutes,
  },
  {path: paths.safety.thank, component: SafetyRoutes, exact: false},
  {path: paths.safety.main, component: SafetyRoutes, exact: true},
  {path: paths.csv.help, component: CsvRoutes, exact: true},
  {path: paths.reason.main, component: ReasonRoutes, exact: true},

  {path: '*', component: NotFoundRoutes, exact: false},
];

export default routing;
